import React from 'react';
import loadable from '@loadable/component';
import Slider from 'react-slick';

import angry from 'assets/images/angry.png';
import problemSolvedPng01 from '../../../assets/images/products/problem-solved/problem-solved-01.png';
import problemSolvedWebp01 from '../../../assets/images/products/problem-solved/problem-solved-01.png?as=webp';

import problemSolvedPng02 from '../../../assets/images/products/problem-solved/problem-solved-02.png';
import problemSolvedWebp02 from '../../../assets/images/products/problem-solved/problem-solved-02.png?as=webp';

import problemSolvedPng03 from '../../../assets/images/products/problem-solved/problem-solved-03.png';
import problemSolvedWebp03 from '../../../assets/images/products/problem-solved/problem-solved-03.png?as=webp';

import problemSolvedPng04 from '../../../assets/images/products/problem-solved/problem-solved-04.png';
import problemSolvedWebp04 from '../../../assets/images/products/problem-solved/problem-solved-04.png?as=webp';

import problemSolvedPng05 from '../../../assets/images/products/problem-solved/problem-solved-05.png';
import problemSolvedWebp05 from '../../../assets/images/products/problem-solved/problem-solved-05.png?as=webp';

import problemSolvedPng06 from '../../../assets/images/products/problem-solved/problem-solved-06.png';
import problemSolvedWebp06 from '../../../assets/images/products/problem-solved/problem-solved-06.png?as=webp';

import problemSolvedPng07 from '../../../assets/images/products/problem-solved/problem-solved-07.png';
import problemSolvedWebp07 from '../../../assets/images/products/problem-solved/problem-solved-07.png?as=webp';

import problemSolvedPng08 from '../../../assets/images/products/problem-solved/problem-solved-08.png';
import problemSolvedWebp08 from '../../../assets/images/products/problem-solved/problem-solved-08.png?as=webp';

import problemSolvedPng09 from '../../../assets/images/products/problem-solved/problem-solved-09.png';
import problemSolvedWebp09 from '../../../assets/images/products/problem-solved/problem-solved-09.png?as=webp';

import problemSolvedPng10 from '../../../assets/images/products/problem-solved/problem-solved-10.png';
import problemSolvedWebp10 from '../../../assets/images/products/problem-solved/problem-solved-10.png?as=webp';

const ImageLoader = loadable(() => import('../common/ImageLoader'));
const LazyImg = loadable(() => import('../common/LazyImg'));

const solvedItems = [
  {
    title: 'You never know if an air purifier is actually working. (!)',
    description: () => (
      <>
        <p>
          Mila is the first purifier to show you how much she’s cleaned. Every time you adjust the fan speed, you’ll see the expected air quality and time to achieve it.
        </p>
        <p>
          It’s as simple as setting your thermostat.
        </p>
      </>
    ),
    image: {
      baseUrl: problemSolvedPng01,
      webpUrl: problemSolvedWebp01,
      alt: 'App live tracking',
    },
  },
  {
    title: 'You need a PhD to figure out what size to buy.',
    description: () => (
      <p>
        Mila is the right size for every room. She learns the size of each space to give you the same level of performance, whether she’s placed in a 150 ft
        <sup>2</sup>
        {' '}
        nursery or a 400 ft
        <sup>2</sup>
        {' '}
        family room.
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng02,
      webpUrl: problemSolvedWebp02,
      alt: 'live room with mila',
    },
  },
  {
    title: 'They market unproven filtration “technology.”',
    description: () => (
      <p>
        Mila uses certified HEPA, the gold standard in fine particle filtration. She also rocks a Clean Air Delivery Rate (CADR) of up to 447 m3/hr (that's more than 2x-5x that of competitors like Dyson and Molekule).
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng03,
      webpUrl: problemSolvedWebp03,
      alt: 'mila Filters',
    },
  },
  {
    title: 'They’re noisy.',
    description: () => (
      <p>
        Mila is smart enough not to disturb you. She's the first purifier to detect room presence, so she knows to quiet down when you enter the room and deep clean when you’re gone.
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng04,
      webpUrl: problemSolvedWebp04,
      alt: 'Mila App notification on screen',
    },
  },
  {
    title: 'They’re ugly.',
    description: () => (
      <p>Mila is cute. 🤗</p>
    ),
    image: {
      baseUrl: problemSolvedPng05,
      webpUrl: problemSolvedWebp05,
      alt: 'Cute Mila Design',
    },
  },
  {
    title: 'They cheat and call a few ounces of carbon dust a “carbon filter.”',
    description: () => (
      <p>
        Filtration of gases depends on the weight and depth of activated carbon. Mila’s patent-pending Dual-Flow filter holds over 1 lb of granular active carbon in a 3-inch bed, giving you best-in-class filtration for household odors and harmful VOCs from paints, carpets, and pressed woods.
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng06,
      webpUrl: problemSolvedWebp06,
      alt: 'Mila with carbon filter',
    },
  },
  {
    title: 'They include one filter that tries to do a little bit of everything—but isn\'t good at anything.',
    description: () => (
      <p>
        Mila lets you choose from  7 custom filters, each purposefully designed to solve a particular home health need —such as pet dander or home renovation dust and chemicals.
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng07,
      webpUrl: problemSolvedWebp07,
      alt: 'Multiple Mila boxes',
    },
  },
  {
    title: 'They come with 3 antiquated speeds —like a blender circa 1984.',
    description: () => (
      <p>
        Mila is far more thoughtful and smart. Her Automagic Mode makes thousands of calculations in the background to determine optimal settings based on room type, time of day, sensor readings, and your personal preferences.
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng08,
      webpUrl: problemSolvedWebp08,
      alt: 'Blender',
    },
  },
  {
    title: 'They hide behind confusing industry lingo.',
    description: () => (
      <p>
        Mila translates the complex science of air quality into plain language, filling you in using terms you can understand.
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng09,
      webpUrl: problemSolvedWebp09,
      alt: 'Hello Mila app',
    },
  },
  {
    title: 'They’re priced like Ferraris and perform like golf carts. 🚗 ',
    description: () => (
      <p>
        Mila delivers twice the value at half the price. Doesn’t everyone deserve to breathe clean air?
      </p>
    ),
    image: {
      baseUrl: problemSolvedPng10,
      webpUrl: problemSolvedWebp10,
      alt: 'Mila performance stats graphic',
    },
  },
];

const ContentSlider = () => {
  const settings = {
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: false,
    pauseOnFocus: false,
    focusOnSelect: true,
    variableWidth: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          autoplay: true,
          infinite: true,
          autoplaySpeed: 5000,
          speed: 500,
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className='content-slider' style={{ '--primary-color': '#F42C52' }}>
      <div className='container container--md'>
        <div className='content-slider__header'>
          <h2 className='content-slider__heading content-slider__heading--lg'>
            Mila solves
            {' '}
            <span>
              10 Big
              {' '}
              <LazyImg src={angry} alt='angry' />
              {' '}
              problems
            </span>
            {' '}
            with today’s air purifiers.
          </h2>
          <h2 className='content-slider__heading content-slider__heading--sm'>
            <span> Mila solves 10</span>
            {' '}
            Big
            {' '}
            <LazyImg src={angry} alt='angry' />
            {' '}
            problems with today’s air purifiers.
          </h2>
          <div className='content-slider__header-description'>
            <p>Designed for pet parents, this award-winning air purifier with a H13 HEPA  + heavy-duty carbon filter removes pet dander and odors to keep your place free of animal funk and allergens.</p>
          </div>
        </div>
        <Slider className='content-slider__grid' {...settings}>
          {solvedItems.map(({ title, description, image }, idx) => (
            <div className='content-slider__item'>
              <div className='content-slider__card'>
                <ImageLoader
                  className='content-slider__image img-relative'
                  placeholderAspectRatio={1 / 1}
                  image={image.baseUrl}
                  webp={image.webpUrl}
                  alt={image.alt}
                />
                <div className='content-slider__body'>
                  <h3 className='content-slider__title'>{`${idx + 1}. ${title}`}</h3>
                  <div className='content-slider__description'>{description()}</div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};
export default ContentSlider;
